import { render, staticRenderFns } from "./AllMessages.vue?vue&type=template&id=7555df84"
import script from "./AllMessages.vue?vue&type=script&lang=js"
export * from "./AllMessages.vue?vue&type=script&lang=js"
import style0 from "./AllMessages.vue?vue&type=style&index=0&id=7555df84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports